<template>
  <div>
    <el-dialog :visible.sync="visible" title="提交审核" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form
          ref="approveRef"
          :model="approveForm"
          label-width="120px"
          style="text-align: left;">
        <el-form-item label="审批分类：">
          <el-select style="width: 70%;" :value="classSelect" placeholder="-请选择-" @change="classSelectChanged">
            <el-option v-for="option in classSelectOptions" :key="option.label" :label="option.value" :value="option.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
            v-for="(item, index) in approveList"
            :key="index"
            :label="`${item.jobName}：`"
            required>
          <el-input style="width: 70%;" v-model="item.approveUserName" clearable></el-input>
          <el-button @click="selectApproveTarget(item)" type="primary">选择</el-button>
        </el-form-item>
      </el-form>
      <el-footer class="container">
        <div class="btnMid">
          <el-button type="info" @click="closeBtn()">取 消</el-button>
          <el-button type="primary" @click="submitBtn()">确 认</el-button>
        </div>
      </el-footer>
    </el-dialog>
    <approve-dialog
        :visible="approveDialogVisible"
        @close="approveDialogClose"
        title="选择审批人员"
        v-bind="approveDialogOptions"
    ></approve-dialog>
  </div>
</template>

<script>
import Consts from "@/utils/consts";
import ApproveDialog from "../meeting/bill/ApproveDialog";
import {
  selectSecondDataDetailService,
  getApproveListService
} from '../../services/sysSettingService'
import  {
  createApproveProcessService,
  saveFrontService,
  saveMiddleService,
} from '../../services/engineering'
export default {
  name: "submit-review",
  data () {
    return {
      visible: false,

      id: '',
      title: '',
      documentNum: '',

      titleIndex: 1,

      classSelect: null,
      classSelectOptions: [],
      approveForm: {
        headOfDepart: {
          // 部门负责人
          id: null,
          name: "",
        },
        leaderOfCompany: {
          // 集团分管领导
          id: null,
          name: "",
        },
      }, // 审批流程
      approveList: [], // 审批流列表

      approveDialogVisible: false,
      approveDialogOptions: {
        approveVO: {},
      }, // 审批流弹出框的配置
    }
  },
  components: {
    ApproveDialog,
  },
  methods:{
    init(){
      this.$nextTick(()=> {
        this.getClassSelectOptions();
      })
    },
    classSelectChanged(val) {
      this.classSelect = val;
      this.getApproveDetail();
    },
    getClassSelectOptions() {
      selectSecondDataDetailService({label: this.titleIndex == 1? "sendDocumentGeneral" :'incomingDocument'}).then(res => {
        if(res.code == Consts.Code_OK) {
          this.visible = true;
          this.classSelectOptions = res.data || []
        } else {
          this.classSelectOptions = [];
        }
      }).catch(() => {})
    },
    // 获取审批信息
    getApproveDetail(){
      let params = {
        orgId: sessionStorage.getItem("orgId"),
        type: this.titleIndex == 1? "sendDocumentGeneral" :  this.titleIndex == 3? 'sendDocumentOthers' : 'incomingDocument',
        subType: this.classSelect
      };
      getApproveListService(params)
          .then((res) => {
            if (res.code == Consts.Code_OK) {
              let list = res.data || [];
              if(list.length == 0){
                this.approveList = [];
                this.$alert('请配置审批流后再提交审核！', "提示");
              }else{
                list.forEach((item) => {
                  item.approveUserId = null;
                  item.approveUserName = "";
                  item.deptId = null;
                  item.deptName = "";
                  item.sort = item.sortId;
                });
                list.sort((a, b) => {
                  return a.sortId - b.sortId;
                }); // 按照sortId排序，从小到大
                this.approveList = [...list];
              }

            } else if (res.code == Consts.Code_Err) {
              this.$alert(res.msg, "提示");
            } else {
              this.$alert(Consts.Err_Msg, "提示");
            }
          })
          .catch((error) => {
            this.$message.error(Consts.Err_Msg);
          });
    },
    selectApproveTarget(item) {
      // 选择对应的审批人
      this.approveDialogOptions = {
        approveVO: item,
      };
      this.approveDialogVisible = true;
    },
    approveDialogClose(data) {
      console.log("审批流程,关闭", data);
      this.approveDialogVisible = false;
      if (data) {
        // 选了人了
        this.approveList.forEach((item) => {
          if (item.jobId == data.jobId) {
            item.approveUserId = data.id;
            item.approveUserName = data.displayName || data.name;
            item.deptId = data.deptId;
            item.deptName = data.deptDisplayName;
            // item.jobId = data.jobId;
            // item.jobName = data.jobDisplayName;
          }
        });
      }
    },

    submitBtn(){
      let isApprove = this.approveList.findIndex(item => item.approveUserId == null|| item.approveUserName == '')
      if(isApprove!= -1 || this.approveList.length == 0){
        this.$message.error('请完善审批流程');
        return
      }
      this.createApprove();
    },
    //创建审批流
    createApprove(){
      let params = {
        approveClass: this.titleIndex == 1? 'OFFICIAL_DOCUMENT_INTERNAL':'OFFICIAL_DOCUMENT_EXTERNAL',
        approveProcessDtoList: this.approveList,
        approveStatusEnum:'UNDERAPLLY',
        itemId: this.id,
        itemName: `${sessionStorage.getItem('name')}关于${this.title}${this.documentNum}的${this.titleIndex == 1||this.titleIndex == 3?'内部公文':'外部公文'}申请`,
      }
      createApproveProcessService(params).then((res) => {
        if (res.code == Consts.Code_OK) {
          this.$message.success('提交审核成功');
          this.$emit('refreshDataList')
          this.visible = false;
        } else {
          this.$alert(res.msg, "提示");
        }
      }).catch((error) => {
        this.$message.error(Consts.Err_Msg);
      });
    },
    closeBtn(){
      this.$emit('refreshDataList')
      this.visible = false;
    },
  }
}
</script>

<style scoped>
/deep/.el-dialog{
  width: 45%;
}
.txt{
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
}
.container{
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>
